import { Path, UseFormSetError } from 'react-hook-form'

type ServerErrors =
  | Record<string, string | string[] | null | undefined>
  | string
  | null
  | undefined

export default function convertServerErrors<T>(
  setError: UseFormSetError<T>,
  errors: ServerErrors,
  rootKeys: string[] = []
) {
  // If there's nothing structured, attach a generic/root error and bail.
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
    const msg =
      (typeof errors === 'string' && errors) ||
      'Something went wrong. Please try again.'
    setError('root' as Path<T>, { type: 'server', message: msg })
    return
  }

  const obj = errors as Record<string, unknown>

  for (const key of Object.keys(obj)) {
    const raw = obj[key]
    const message = Array.isArray(raw)
      ? raw.filter(Boolean).join(', ')
      : raw != null
      ? String(raw)
      : ''

    if (!message) continue

    if (key === 'base') {
      setError('root' as Path<T>, { type: 'server', message })
    } else if (rootKeys.includes(key)) {
      // rootKeys are attached under errors.root.KEY
      setError(`root.${key}` as Path<T>, { type: 'server', message })
    } else {
      setError(key as Path<T>, { type: 'server', message })
    }
  }
}
